import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/polls/poll-option.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Motion, presets, spring } from 'react-motion';
import { HStack, Icon, Text } from '../ui';
const messages = defineMessages({
  voted: {
    "id": "poll.voted",
    "defaultMessage": "You voted for this answer"
  },
  votes: {
    "id": "poll.votes",
    "defaultMessage": "{votes, plural, one {# vote} other {# votes}}"
  }
});
const PollPercentageBar = ({
  percent,
  leading
}) => {
  return /*#__PURE__*/React.createElement(Motion, {
    defaultStyle: {
      width: 0
    },
    style: {
      width: spring(percent, _objectSpread(_objectSpread({}, presets.gentle), {}, {
        precision: 0.1
      }))
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, ({
    width
  }) => /*#__PURE__*/React.createElement("span", {
    className: "absolute inset-0 h-full inline-block bg-primary-100 dark:bg-primary-500 rounded-l-md",
    style: {
      width: `${width}%`
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }));
};
const PollOptionText = ({
  poll,
  option,
  index,
  active,
  onToggle
}) => {
  const handleOptionChange = () => onToggle(index);
  const handleOptionKeyPress = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      onToggle(index);
      e.stopPropagation();
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement("label", {
    className: classNames('flex relative p-2 bg-white dark:bg-primary-900 cursor-pointer border border-solid hover:bg-primary-50 dark:hover:bg-primary-800/50', {
      'border-primary-600 ring-1 ring-primary-600 bg-primary-50 dark:bg-primary-800/50 dark:border-primary-300 dark:ring-primary-300': active,
      'border-primary-300 dark:border-primary-500': !active,
      'rounded-3xl': poll.multiple !== true,
      'rounded-xl': poll.multiple
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "hidden",
    name: "vote-options",
    type: poll.multiple ? 'checkbox' : 'radio',
    value: index,
    checked: active,
    onChange: handleOptionChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid items-center w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-start-1 row-start-1 justify-self-center ml-4 mr-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary-600 dark:text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "inherit",
    weight: "medium",
    dangerouslySetInnerHTML: {
      __html: option.title_emojified
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-start-1 row-start-1 justify-self-end flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('flex items-center justify-center w-6 h-6 flex-none border border-solid', {
      'bg-primary-600 border-primary-600 dark:bg-primary-300 dark:border-primary-300': active,
      'border-primary-300 bg-white dark:bg-primary-900 dark:border-primary-500': !active,
      'rounded-full': poll.multiple !== true,
      'rounded': poll.multiple
    }),
    tabIndex: 0,
    role: poll.multiple ? 'checkbox' : 'radio',
    onKeyPress: handleOptionKeyPress,
    "aria-checked": active,
    "aria-label": option.title,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 11
    }
  }, active && /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/check.svg'),
    className: "text-white dark:text-primary-900 w-4 h-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 15
    }
  })))));
};
const PollOption = props => {
  const {
    index,
    poll,
    option,
    showResults
  } = props;
  const intl = useIntl();
  if (!poll) return null;
  const pollVotesCount = poll.votes_count;
  const percent = pollVotesCount === 0 ? 0 : option.votes_count / pollVotesCount * 100;
  const leading = poll.options.filterNot(other => other.title === option.title).every(other => option.votes_count >= other.votes_count);
  const voted = poll.own_votes?.includes(index);
  const message = intl.formatMessage(messages.votes, {
    votes: option.votes_count
  });
  return /*#__PURE__*/React.createElement("div", {
    key: option.title,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 5
    }
  }, showResults ? /*#__PURE__*/React.createElement("div", {
    title: voted ? message : undefined,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "between",
    alignItems: "center",
    className: "relative p-2 w-full bg-white dark:bg-primary-800 rounded-md overflow-hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(PollPercentageBar, {
    percent: percent,
    leading: leading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-primary-600 dark:text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "inherit",
    weight: "medium",
    dangerouslySetInnerHTML: {
      __html: option.title_emojified
    },
    className: "relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    alignItems: "center",
    className: "relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 13
    }
  }, voted ? /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-check.svg'),
    alt: intl.formatMessage(messages.voted),
    className: "text-primary-600 dark:text-primary-800 dark:fill-white w-4 h-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 17
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "svg-icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-primary-600 dark:text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 154,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    theme: "inherit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 17
    }
  }, Math.round(percent), "%"))))) : /*#__PURE__*/React.createElement(PollOptionText, _extends({
    percent: percent
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 161,
      columnNumber: 9
    }
  })));
};
export default PollOption;